import {createAction, handleActions} from "redux-actions";

const SET_FAMILY_DATA = 'family/SET_FAMILY_DATA';
const LOAD_FAMILY = 'family/LOAD_FAMILY';
const REMOVE_FAMILY_DATA = 'family/REMOVE_FAMILY_DATA';

export const setFamilyData = createAction(SET_FAMILY_DATA, ({seq, family}) => ({
    seq,
    family
}));

export const loadFamily = createAction(LOAD_FAMILY, ({family}) =>
    family
);

export const removeFamilyData = createAction(REMOVE_FAMILY_DATA, ({fmifSeq}) => fmifSeq);

const initialState = {
    family: {}
};

const family = handleActions(
    {
        [SET_FAMILY_DATA]: (state, action) => {
            const newState = {
                ...state
            };
            newState.family[action.payload.seq] = action.payload.family;
            return newState;
        },
        [LOAD_FAMILY]: (state, action) => {
            state.family = action.payload;
            return state;
        },
        [REMOVE_FAMILY_DATA]: (state, action) => {
            delete state.family[action.payload];
            const newState = {
                ...state
            };

            return newState;
        }
    },
    initialState
);

export default family;
